module.exports = __webpack_public_path__ + "img/lock.381d6b16.jpg";